import React from 'react'

class LogoTimur extends React.Component {
    render() {
        return (

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                <g fill="none" fill-rule="evenodd">
                    <path fill="#FEEF8E" d="M286.137 187.468c0-71.795-58.198-129.997-129.987-129.997-71.79 0-129.988 58.21-129.988 130s58.198 130 129.988 130c71.79 0 129.987-58.2 129.987-129.994"/>
                    <path fill="#74CBCB" d="M313.212 188.253c-2.88-1.905-11.75-2.795-11.75-2.795l.003.004c-2.212-.37-4.723-.582-7.598-.575-21.68.05-25.772-18.79-52.525-39.8-26.752-21.007-70.165.57-70.165.57-5.883-6.128-14.17-41.668-14.17-41.668-11.766 5.73-10.984 30.26-10.984 30.26-16.613-47.19-26.363-35.66-26.363-35.66-17.296 19.627-46.144 160.362-46.144 160.362-10.96 111.798 107.05 199.967 107.05 199.967 2.9-16.204 44.74-53.946 63.83-68.445 57.957-44.02 29.71-95.728 29.71-95.728 18.984-2.565 36.96-22.597 24.984-20.835-12.116 1.78-14.6-5.99-14.6-5.99s2.213.08 5.49-.255l1.52 3.444 3.266-4.16 2.326 5.264s3.14-3.587 3.707-6.91c5.31-1.89 10.65-5.128 13.81-10.694 8.042-14.14 5.46-46.36 3.994-52.062 3.854-5.276-2.52-12.39-5.4-14.292"/>
                    <path fill="#FEFEFE" d="M236.15 196.436l-24.608-11.924-2.1 4.332 24.607 11.925"/>
                    <path fill="#FEFEFE" d="M230.922 181.386l-11.92 24.608-4.332-2.1 11.92-24.607"/>
                </g>
            </svg>

        );
    }
}

export default LogoTimur



// WEBPACK FOOTER //
// ../components/SVG/LogoTimur.jsx